import React from 'react';

const ProjectCard = ({ project }) => {
    const { img, tag, live, server, client, title, tec } = project
    const tagitem= tag.split(",")
    return (

            <div className="project-card mt-1 mb-5">
                <div className="pro-img" style={{height:"500px", overflow:"hidden", backgroundImage:`url(${img})`, backgroundSize:"cover"}}>            
                <div className="overlay2"></div>            
                </div>           
            <div className="hover">
                <span className='one1'></span>
                <span className='one2'></span>
                <span className='one3'></span>
                <span className='one4'></span>
               
                <a href={live} target="_blank" rel="noreferrer" className='buy-btn'  >Live Website</a>
                <a href={client} target="_blank" rel="noreferrer"  >Client Code</a>
               {server &&  <a href={server} target="_blank" rel="noreferrer"  >Server Code</a>}
           
            
            </div>
            <div className="body-text p-3">
                <div className="button">
                {
                    tagitem.map(item => <button>{item }</button>)
                }
                </div>
            
                <p>{title}</p>
                <div className="tec">
                    <h3>Technology: {tec.map(item => <a> { item},</a>) }
                    </h3>
                </div>
            </div>
            </div>
               
            
            
 )
};

export default ProjectCard;